

























































































































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers } from '@/mixins';
import {
  DocuSignTemplateModel,
  BaseResultModel,
  DocuSignTemplateConfigurationModel,
  ArenaSignTemplateCreateUpdateModel,
  Dictionary,
  Configuration
} from '@/types';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';

export default Vue.extend({
  name: 'DocusignEditTemplate',
  mixins: [FormFieldValidation, RouteHelpers],
  data() {
    return {
      isLoading: true,
      docuSignTemplate: {} as DocuSignTemplateModel,
      docuSignTemplateConfigurationModel: {} as DocuSignTemplateConfigurationModel,
      submitIsLoading: false,
      hasError: false,
      errorMessage: ''
    };
  },
  methods: {
    async onSubmit(this: any) {
      this.resetFormValidation();
      try {
        const isValid = await this.$validator.validate();
        if (isValid) {
          this.submitIsLoading = true;

          const result: BaseResultModel = await DocuSignConfigurationService.updateTemplateAsync(
            this.docuSignTemplate.id,
            {
              documentTypeId: this.docuSignTemplate.documentTypeId,
              template: this.docuSignTemplate.template
            } as ArenaSignTemplateCreateUpdateModel
          );

          if (result.hasNotification && !result.showToast) {
            this.addFormValidationError(result.notification);
            this.submitIsLoading = false;
            return;
          }

          SnotifyConfiguration.showSuccess('Template updated successfully.');
          this.setApplicationDirty(false);
          this.navigateToTemplateTabManagement();
        }
      } catch (error) {
        this.$log('Error updating template', error);
      } finally {
        this.submitIsLoading = false;
      }
    },
    async getTemplateAsync(this: any) {
      this.isLoading = true;
      try {
        this.docuSignTemplateConfigurationModel = await DocuSignConfigurationService.getTemplateConfigurationAsync({
          documentTypeId: this.documentTypeId,
          templateId: this.templateId
        });
        this.docuSignTemplate = this.docuSignTemplateConfigurationModel.template;
      } catch (error) {
        this.docuSignTemplate = {} as DocuSignTemplateModel;
        this.$log('Error getting template');
      } finally {
        this.isLoading = false;
      }
    },
    onCancel(this: any) {
      this.navigateToTemplateTabManagement();
    },
    navigateToTemplateTabManagement(this: any) {
      this.navigateToRoute(Configuration.DocuSign.Template.Management.name, this.documentTypeId);
    },
    navigateToTemplateSignHereManagement(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      this.$router.push({
        name: Configuration.DocuSign.TemplateSignHere.Management.name,
        params: param
      });
    },
    navigateToTemplateAdditionalDocumentManagement(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      this.$router.push({
        name: Configuration.DocuSign.TemplateAdditionalDocument.Management.name,
        params: param
      });
    }
  },
  computed: {
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    templateId(): number {
      return Number(this.$route.params.id);
    },
    headerText(this: any) {
      return this.docuSignTemplate?.template ? `Edit Template (${this.docuSignTemplate.template})` : 'Edit Template';
    },
    signHereCount(this: any) {
      const count = this.docuSignTemplate?.templateSignHeres ? this.docuSignTemplate?.templateSignHeres.length : 0;
      return count > 0 ? count : '';
    },
    additionalDocumentCount(this: any) {
      const count = this.docuSignTemplate?.additionalDocuments
        ? this.docuSignTemplate?.additionalDocuments.length
        : 0;
      return count > 0 ? count : '';
    }
  },
  mounted(this: any) {
    this.getTemplateAsync();
  },
  components: {
    LoadingSpinner,
    MStoreTable
  }
});
